import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import { useQuasar } from 'quasar';
import { useMetaStore } from '@/stores/meta';
import { getMetaTags } from '@/utils/metaTags';
import { useAuthStore } from '@/stores/auth';
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  // Add the following functions
  // function setSessionCookie(name: string, value: string) {
  //   document.cookie = `${name}=${value}; path=/`;
  // }
  // Add the router guard
  Router.beforeEach(async (to, from, next) => {
    const $q = useQuasar();
    const authStore = useAuthStore(store);
    const isUnlocked = $q.cookies.get('unlocked');
    const metaTags = await getMetaTags(to) as any;
    to.meta = metaTags;
    const metaStore = useMetaStore(store);
    metaStore.setMetaTags(metaTags);
    // if (isUnlocked || to.name === 'PasswordPage' || to.name === 'PrivacyPage') {
    //   next();
    // } else {
    //   next({ name: 'PasswordPage' });
    // }

    const backendRedirectFromQuery = to.query.redirect as string | undefined;
    if (backendRedirectFromQuery && authStore.isLoggedIn) {
      window.location.href = `${backendRedirectFromQuery}?token=${authStore.getToken()}`;
      return;
    }

    next();
    if (
      (to.name === 'login' || to.name === 'register') &&
      store.state.value.auth.token
    ) {
      window.history.replaceState({}, '', from.fullPath);
    }
  });

  return Router;
});
